module["exports"] = [
  "كتب",
  "ألعاب",
  "إلكترونيات",
  "حواسيب",
  "بيت",
  "Garden",
  "أدوات",
  "Grocery",
  "صحة",
  "جمال",
  "Toys",
  "أطفال",
  "رضع",
  "ملابس",
  "أحذية",
  "Jewelery",
  "أغراض رياضية",
  "Outdoors",
  "Automotive",
  "صناعة"
];
